module.exports = __webpack_public_path__ + "img/icon16-call-internal-danger.cda7d825.svg";